<template>
    <div>
        <!-- TOAST PARA LOS MENSAJES -->
        <div class="p-d-flex">
            <Toast />
        </div>
        <!-- DIALOGO DE LOADING -->
        <Dialog :baseZIndex="2" :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }">
            <ProgressBar mode="indeterminate" style="height: 0.5em" />
            <span>{{ loadingMensaje }}</span>
        </Dialog>
        <!-- NUEVO TRABAJADOR -->
        <Dialog :showHeader="false" position="top" :visible.sync="dialogTrabajador" :closeOnEscape="true"
        :closable="false" :modal="false" :style="{ width: '95vw' }" class="border-round">
            <ComponentTrabajador @closeDialogTrabajador="dialogTrabajador = false"></ComponentTrabajador>
        </Dialog>
        <!-- LISTA DE TRABAJADORES -->
        <DataTable :value="listTrabajadores" :scrollable="true" scrollHeight="400px" scrollDirection="both" :paginator="true" :rows="10" responsiveLayout="scroll" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10,20,50]" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" >
            <template #header>
                <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                    <div class="field col-6 text-left" >
                        <h1>Trabajadores</h1>
                    </div>
                    <div class="field col-6 text-right">
                        <Button icon="pi pi-plus" class="p-button-rounded p-button-success p-button-outlined mr-1" @click="NuevoTrabajador"/>
                        <Button icon="pi pi-replay" class="p-button-rounded p-button-info p-button-outlined" @click="GetTrabajadores"/>
                    </div>
                </div>
            </template>
            <Column header="Acciones" :styles="{'flex-grow':'1', 'flex-basis':'10px'}" frozen>
                <template #body="slotProps">
                    <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mr-1" v-tooltip.bottom="'Eliminar'" />
                    <Button icon="pi pi-pencil" class="p-button-rounded p-button-info" v-tooltip.bottom="'Editar'" />
                </template>
            </Column>
            <Column field="numEmpleado" header="Num. Empleado" :styles="{'flex-grow':'1', 'flex-basis':'100px'}"></Column>
            <Column field="nombre" header="Nombre" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
            <Column field="rfc" header="RFC" :styles="{'flex-grow':'1', 'flex-basis':'100px'}"></Column>
            <Column field="curp" header="CURP" :styles="{'flex-grow':'1', 'flex-basis':'100px'}"></Column>
        </DataTable>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import ComponentTrabajador from './Trabajador'

    export default {
        components: {
            ComponentTrabajador,
        },
        data() {
            return {
                loading: false,
                loadingMensaje: '',
                dialogTrabajador: false,
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            listTrabajadores(){
                return this.$store.state.trabajadoresStore;
            },
        },
        created() {
            this.Iniciales();
        },
        methods: {
            async Iniciales(){
                this.loading = true;
                await this.GetTrabajadores();
                await this.GetTipoContrato();
                await this.GetTipoJornada();
                await this.GetTipoRegimen();
                await this.GetRiesgoPuesto();
                await this.GeTPeriodicidadPago();
                await this.GetBanco();
                await this.GetClaveEntFed();
                this.loading = false;
            },
            async GetTrabajadores(){
                try{
                    this.loadingMensaje = 'Consultando Trabajadores...';
                    let respuesta = await axios.get("Nomina/GetTrabajadores/"+ this.token.empresaBase);
                    let x =  respuesta.data;
                    this.$store.state.trabajadoresStore = x;
                }catch(error){
                    console.log(error);
                }
            },
            async GetTipoContrato(){
                try{
                    if(this.$store.state.tipoContratoStore.length != 0){
                        return;
                    }
                    this.loadingMensaje = 'Consultando Tipo de Contrato...';
                    let respuesta = await axios.get("Nomina/GetTipoContrato/");
                    let x =  respuesta.data;
                    this.$store.state.tipoContratoStore = x;
                }catch(error){
                    console.log(error);
                }
            },
            async GetTipoJornada(){
                try{
                    if(this.$store.state.tipoJornadaStore.length != 0){
                        return;
                    }
                    this.loadingMensaje = 'Consultando Tipo de Jornada...';
                    let respuesta = await axios.get("Nomina/GetTipoJornada/");
                    let x =  respuesta.data;
                    this.$store.state.tipoJornadaStore = x;
                }catch(error){
                    console.log(error);
                }
            },
            async GetTipoRegimen(){
                try{
                    if(this.$store.state.tipoRegimenStore.length != 0){
                        return;
                    }
                    this.loadingMensaje = 'Consultando Tipo de Régimen...';
                    let respuesta = await axios.get("Nomina/GetTipoRegimen/");
                    let x =  respuesta.data;
                    this.$store.state.tipoRegimenStore = x;
                }catch(error){
                    console.log(error);
                }
            },
            async GetRiesgoPuesto(){
                try{
                    if(this.$store.state.riesgoPuestoStore.length != 0){
                        return;
                    }
                    this.loadingMensaje = 'Consultando Riesgo de Puesto...';
                    let respuesta = await axios.get("Nomina/GetRiesgoPuesto/");
                    let x =  respuesta.data;
                    this.$store.state.riesgoPuestoStore = x;
                }catch(error){
                    console.log(error);
                }
            },
            async GeTPeriodicidadPago(){
                try{
                    if(this.$store.state.periodicidadPagoStore.length != 0){
                        return;
                    }
                    this.loadingMensaje = 'Consultando Periodicidad de Pago...';
                    let respuesta = await axios.get("Nomina/GetPeriodicidad/");
                    let x =  respuesta.data;
                    this.$store.state.periodicidadPagoStore = x;
                }catch(error){
                    console.log(error);
                }
            },
            async GetBanco(){
                try{
                    if(this.$store.state.bancoStore.length != 0){
                        return;
                    }
                    this.loadingMensaje = 'Consultando Banco...';
                    let respuesta = await axios.get("Nomina/GetBanco/");
                    let x =  respuesta.data;
                    this.$store.state.bancoStore = x;
                }catch(error){
                    console.log(error);
                }
            },
            async GetClaveEntFed(){
                try{
                    if(this.$store.state.claveEntFedStore.length != 0){
                        return;
                    }
                    this.loadingMensaje = 'Consultando Clave de Entidad Federativa...';
                    let respuesta = await axios.get("Nomina/GetClaveEntFed/");
                    let x =  respuesta.data;
                    this.$store.state.claveEntFedStore = x;
                }catch(error){
                    console.log(error);
                }
            },

            NuevoTrabajador(){
                let ObjTrabajador = {
                    id: 0,
                    nombre: '',
                    rfc: '',
                    curp: '',
                    numSeguridadSocial: '',
                    fechaInicioRelLaboral: new Date(),
                    antiguedad: '',
                    tipoContrato: {},
                    sindicalizado: '',
                    tipoJornada: {},
                    tipoRegimen: {},
                    numEmpleado: '',
                    departamento: '',
                    puesto: '',
                    riesgoPuesto: {},
                    periodicidadPago: {},
                    banco: {},
                    cuentaBancaria: '',
                    salarioBaseCotApor: 0,
                    salarioDiarioIntegrado: 0,
                    claveEntFed: {},
                    subContrataciones: [],
                    empresa: '',
                    folioFiscal: '',
                    correo: '',
                };
                this.$store.state.trabajadorStore = { ...ObjTrabajador }
                this.$store.state
                this.dialogTrabajador = true;
            },
        },
    }
    </script>
    <style>

    </style>